<template>
  <TopBarIndex />
  <div class="container pt-5">
    <div class="card mt-5">
      <div class="card-body">
        <div class="d-flex">
          <img class="mr-2" src="/assets/images/svg/icon/user.svg" alt="user">
          <h4 class="text-success">個人資訊</h4>
        </div>

        <hr>

        <div class="row">
          <div class="col-12">
            <div class="card-title d-flex justify-content-between align-items-center mb-4">
              基本資料
              <button class="btn btn-sm btn-success waves-light waves-effect" @click="editModal1">
                <i class="fas fa-edit mr-2"></i>修改基本資料
              </button>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <input-component label="使用者名稱" :value="user.name" readonly></input-component>
          </div>
          <div class="col-lg-4 col-md-6">
            <input-component label="電子信箱" :value="user.email" readonly></input-component>
          </div>
          <div class="col-lg-4 col-md-6">
            <input-component label="聯絡電話" :value="user.phone" readonly></input-component>
          </div>
        </div>

        <hr>

        <div class="row">
          <div class="col-12">
            <div class="card-title d-flex justify-content-between align-items-center mb-4">
              登入密碼
              <button class="btn btn-sm btn-success waves-light waves-effect" @click="editModal2">
                <i class="fas fa-edit mr-2"></i>修改密碼
              </button>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <input-component label="密碼" value="xxxxxxxxx" readonly></input-component>
          </div>
        </div>

        <hr>

        <div class="row">
          <div class="col-12">
            <div class="card-title d-flex justify-content-between align-items-center mb-4">
              工作資訊
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <input-component label="帳號" :value="user.account" readonly></input-component>
          </div>
          <div class="col-lg-4 col-md-6">
            <input-component label="角色分類" :value="role_category" readonly></input-component>
          </div>
          <div class="col-lg-4 col-md-6">
            <input-component label="用戶角色" :value="role_name" readonly></input-component>
          </div>
          <div class="col-lg-4 col-md-6">
            <input-component label="所屬區域" :value="area_name" readonly></input-component>
          </div>
          <div class="col-lg-4 col-md-6">
            <input-component label="所屬單位" :value="user.company_name" readonly
              v-if="role_category_id != 5"></input-component>
          </div>
          <div class="col-lg-4 col-md-6">
            <input-component label="主要廠商" :value="major_manufacturer_name" readonly
              v-if="role_category_id  == 5"></input-component>
          </div>
          <div class="col-lg-4 col-md-6">
            <input-component label="委外廠商" :value="outsource_manufacturer_name" readonly
              v-if="role_category_id  == 5"></input-component>
          </div>
          <div class="col-lg-4 col-md-6">
            <input-component label="工班編號" :value="user.maintenance_class_id" readonly
              v-if="role_category_id  == 5"></input-component>
          </div>
          <div class="col-lg-4 col-md-6">
            <input-component label="領班編號" :value="user.leader_class_id" readonly
              v-if="role_category_id  == 5"></input-component>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 修改基本資料 modal start -->
  <div id="edit-modal1" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header d-flex align-items-center">
          <h4 class="modal-title m-0">修改基本資料</h4>
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"> × </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <input-component label="使用者名稱" v-model="name" required disabled></input-component>
            </div>
            <div class="col-12">
              <input-component label="電子信箱" v-model="email" type="email" required></input-component>
            </div>
            <div class="col-12">
              <input-component label="聯絡電話" v-model="phone" required></input-component>
            </div>

          </div>
        </div>
        <div class="modal-footer px-0">
          <button type="button" class="btn btn-light waves-effect" data-dismiss="modal">取消</button>
          <button type="button" class="btn btn-info waves-effect" @click="setBaseInfo">確認</button>
        </div>

      </div>
    </div>
  </div>
  <!-- 修改基本資料 modal end -->

  <!-- 修改密碼 modal start -->
  <div id="edit-modal2" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header d-flex align-items-center">
          <h4 class="modal-title m-0">修改密碼</h4>
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"> × </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <input-component v-model="pwd" label="新密碼(8~16字元，含大小寫英文及數字)" type="password" required></input-component>
            </div>
            <div class="col-12">
              <input-component v-model="confirmPwd" label="再次輸入新密碼" type="password" required></input-component>
            </div>
          </div>
        </div>
        <div class="modal-footer px-0">
          <button type="button" class="btn btn-light waves-effect" data-dismiss="modal">取消</button>
          <button type="button" class="btn btn-info waves-effect" @click="setPwd">確認</button>
        </div>

      </div>
    </div>
  </div>
  <!-- 修改密碼 modal end -->

</template>

<script>
/* eslint-disable */
import { IsNullOrEmpty, GetQueryString } from "../../../components/helpers.js"
import { api } from "../../../apis/main.js"
import TopBarIndex from "../../../components/TopBarIndex.vue"
import SelectComponent from '../../../components/form/SelectComponent.js';
import InputComponent from '../../../components/form/InputComponent.js';

let $ = window.$;
export default {
  name: 'ProfileView',
  props: {
  },
  components: {
    TopBarIndex,
    SelectComponent,
    InputComponent
  },
  data() {
    return {
      user: {},
      role_name: '',
      role_category: '',
      role_category_id: null,
      major_manufacturer_name: '',
      outsource_manufacturer_name: '',
      name: '',
      email: '',
      phone: '',
      pwd: '',
      confirmPwd: '',
    }

  },
  mounted() {
    this.getProfile();
  },
  computed: {
    area_name() {
      return this.user.district_list?.map(d => d.name).join(',');
    }
  },
  watch: {
  },
  methods: {
    getProfile() {
      api.post('user_profile').then(res => {
        this.user = res.data.User;
        this.name = this.user.name;
        this.email = this.user.email;
        this.phone = this.user.phone;
        this.role_name = res.data.role_name;
        this.role_category = res.data.role_category;
        this.role_category_id = res.data.role_category_id;
        this.major_manufacturer_name = res.data.major_manufacturer_name;
        this.outsource_manufacturer_name = res.data.outsource_manufacturer_name;
      });
    },
    editModal1() {
      this.name = this.user.name;
      this.email = this.user.email;
      this.phone = this.user.phone;
      $('#edit-modal1').modal('show')
    },
    editModal2() {
      this.pwd = '';
      this.confirmPwd = '';
      $('#edit-modal2').modal('show')
    },
    setBaseInfo() {
      if (IsNullOrEmpty(this.name) ||
        IsNullOrEmpty(this.email) ||
        IsNullOrEmpty(this.phone)) {
        swal({
          title: "Opps!",
          type: "warning",
          html: true,
          text:
            "<label class='h6'>請輸入必填資料</label>"
        });
        return;
      }
      let tmp = {
        name: this.name,
        email: this.email,
        phone: this.phone
      };
      api.post('user_profile_edit', GetQueryString(tmp)).then(res => {
        this.getProfile();
        toastr.success('資料已修改!');
        $('#edit-modal1').modal('hide');
      })

    },
    setPwd() {
      let showError = function (str) {
        swal({
          title: "Opps!",
          type: "warning",
          html: true,
          text:
            "<label class='h6'>" +
            str +
            "</label>",
        });
      }
      if (this.pwd !== this.confirmPwd) {
        showError('輸入密碼不一致');
        return;
      }
      let tmp = {
        new_password: this.pwd,
        new_password_2: this.confirmPwd
      };
      api.post('user_profile_reset_password', GetQueryString(tmp)).then(res => {
        this.getProfile();
        toastr.success('密碼已修改!');
        $('#edit-modal2').modal('hide');
      }).catch(error => {
        showError(error.response.data.detail);
      });
    }
  }
}
</script>

<style scoped>

</style>
